<!-- PROCESO MANUAL -->
<tec-pwcs-layout
    [ngClass]="{
        'pwcs-style-old': operation.config?.iframe,
        dark: designService.isDarkMode(),
        'hide-subtitle': !(operation?.config.tutorial || pageWarning.show || handsetLandscape || !selectedDocumentType),
        'take-photo': !capturedImage && !(operation?.config.tutorial || pageWarning.show || handsetLandscape)
    }"
    [title]="pageWarning.type === PAGE_WARNING.HELP ? (helpTitle | translate) : ''"
    [subtitle]="!handsetLandscape ? subtitle : ''"
    [footerLabel]="
        operation?.config.tutorial && !pageWarning.show && permissionsCamera && !handsetLandscape
            ? ('GENERAL.TUTORIAL_ENCRYPTION' | translate)
            : ''
    "
>
    <tec-progress [value]="progressService.getValue(manualOcrConf)"></tec-progress>

    <ng-container content>
        <!-- SIN PERMISOS -->
        @if (!permissionsCamera) {
            <tec-tile
                type="status"
                [title]="'GENERAL.ERROR.NO_PERMISSION_CAMERA_TITLE' | translate"
                [subtitle]="'GENERAL.ERROR.NO_PERMISSION_CAMERA_DESCRIPTION' | translate"
                icon="icon-alert"
            >
                <tec-link
                    [label]="'LIFE_CHECK.HELP.TITLE' | translate"
                    (click)="isVisibleHelpNoPermissionsCamera = true"
                ></tec-link>
            </tec-tile>
        }

        <!-- CON PERMISOS -->
        @if (permissionsCamera) {
            <!-- MAIN -->
            <div
                class="content__identity"
                [ngStyle]="{
                    display: operation?.config.tutorial || pageWarning.show || handsetLandscape ? 'none' : 'contents'
                }"
            >
                @if (loading.show) {
                    <tec-spinner
                        [show]="loading.show"
                        [opaque]="true"
                        [text]="loading.text"
                        [img]="designService.getCustomSpinnerUrl() || undefined"
                    ></tec-spinner>
                }

                @if (!selectedDocumentType) {
                    <div class="select-document-type">
                        @for (doc of allowedDocumentTypes; track doc; let i = $index) {
                            <tec-card-access
                                [type]="'default'"
                                [size]="'default'"
                                [title]="getAllowedDocumentTypeTitle(doc)"
                                [tagImage]="{ icon: 'icon-card', status: getTagImageStatusByIndex(i) }"
                                (click)="selectDocumentType(doc.type, doc.dniScope)"
                            ></tec-card-access>
                        }
                    </div>
                }

                <div [ngStyle]="{ display: !selectedDocumentType ? 'none' : 'block' }" class="video">
                    <app-video
                        [ngClass]="{ 'video-hidden': capturedImage }"
                        [constraints]="ocrService.constraints"
                        [forceFlipHorizontal]="forceFlipHorizontal"
                        [enableTapToFocus]="!capturedImage && !loading.show && !!selectedDocumentType"
                        (cameraError)="onCameraError($event)"
                        (cameraPermissionRevoked)="onCameraPermissionRevoked()"
                        (cameraStarted)="onCameraStarted($event)"
                        (cameraSwitchStarted)="onCameraSwitchStarted()"
                        (cameraSwitchCompleted)="onCameraSwitchCompleted()"
                    ></app-video>

                    <!-- Imagen capturada superpuesta -->
                    @if (capturedImage) {
                        <img [src]="capturedImage" />
                    }
                </div>

                @if (!loading.show && selectedDocumentType) {
                    <span class="content__identity__subtitle-mobile" [innerHTML]="subtitle"></span>
                }

                @if (selectedDocumentType && getCurrentPhotoNumber() === 1 && !loading.show) {
                    <tec-link [label]="'OCR.MANUAL.CHANGE_DOCUMENT' | translate" (click)="resetDocumentType()"></tec-link>
                }

                <!-- BOTON CAMBIO CAMARA -->
                @if (operation?.config?.iframe && allCameras && allCameras.length > 1) {
                    <div class="change-camera">
                        <span>{{ 'GENERAL.BUTTON.CHANGE_CAMERA' | translate }}</span>
                        <tec-button-icon
                            icon="icon-refresh"
                            type="circle"
                            size="lg"
                            (clickEvent)="changeCamera()"
                        ></tec-button-icon>
                    </div>
                }

                <!-- QR -->
                @if (operation?.config?.iframe && !loading.show) {
                    <div [ngClass]="{ widget: true, open: openQR }">
                        <div class="widget__intro">
                            <h6>{{ 'GENERAL.QR.TITLE' | translate }}</h6>
                            <span>{{ 'GENERAL.QR.DESCRIPTION' | translate }}</span>
                        </div>
                        <div class="widget__content">
                            <div class="widget__content__qr" id="qrcode2" [title]="auth.getQRUrl()">
                                <tec-qr [url]="auth.getQRUrl()" />
                            </div>
                            <p class="widget__content__url">{{ auth.getQRUrl() }}</p>
                        </div>
                        <button class="button button-icon" (click)="openQR = !openQR">
                            <i class="icon-chevron-down"></i>
                        </button>
                    </div>
                }
            </div>

            <!-- TUTORIAL -->
            @if (operation?.config.tutorial && !pageWarning.show && !handsetLandscape) {
                <div class="tutorial-image">
                    <pwcs-inline-svg
                        [src]="getDniPhotoSideAsset('assets/images/doc-reverse.svg')"
                        idSuffix="manual-ocr-tutorial-doc"
                    />
                </div>
            }

            <!-- HELP -->
            @if (pageWarning.show) {
                @if (pageWarning.type === PAGE_WARNING.HELP) {
                    @if (restrictionErrorMsg) {
                        <tec-alert
                            [msg]="restrictionErrorMsg"
                            type="message"
                            status="error"
                            hiddenCloseButton
                            icon="icon-alert"
                        ></tec-alert>
                    }
                    <div
                        class="tile tile--help"
                        [class.pwcs-dni-photo-right]="operation?.config?.dni_wireframe_photo_side === 'right'">
                        <div class="image-group">
                            <pwcs-inline-svg
                                [src]="getDniPhotoSideAsset('assets/images/id-blurred.svg')"
                                idSuffix="manual-ocr-help-id-blurred"
                            />
                            <p>
                                <span>{{ 'OCR.BACK.MODAL_HELP.TIP_1' | translate }}</span>
                            </p>
                        </div>
                        <div class="image-group">
                            <pwcs-inline-svg
                                [src]="getDniPhotoSideAsset('assets/images/id-bright.svg')"
                                idSuffix="manual-ocr-help-id-bright"
                            />
                            <p>
                                <span>{{ 'OCR.BACK.MODAL_HELP.TIP_2' | translate }}</span>
                            </p>
                        </div>
                        <div class="image-group">
                            <pwcs-inline-svg
                                [src]="getDniPhotoSideAsset('assets/images/id-cut.svg')"
                                idSuffix="manual-ocr-help-id-cut"
                            />
                            <p>
                                <span>{{ 'OCR.BACK.MODAL_HELP.TIP_3' | translate }}</span>
                            </p>
                        </div>
                        <div class="image-group">
                            <pwcs-inline-svg
                                [src]="getDniPhotoSideAsset('assets/images/id-finger.svg')"
                                idSuffix="manual-ocr-help-id-finger"
                            />
                            <p>
                                <span>{{ 'OCR.BACK.MODAL_HELP.TIP_6' | translate }}</span>
                            </p>
                        </div>
                    </div>
                    <tec-alert
                        [msg]="'OCR.BACK.MODAL_HELP.TIP_5' | translate"
                        type="message"
                        hiddenCloseButton
                        icon="icon-info"
                    ></tec-alert>
                }
                @if (pageWarning.type === PAGE_WARNING.VERIFICATION_FAIL) {
                    <tec-tile
                        type="status"
                        [title]="'LIFE_CHECK.PAGE_WARNING.VERIFICATION_FAIL.TITLE' | translate"
                        [subtitle]="'LIFE_CHECK.PAGE_WARNING.VERIFICATION_FAIL.DESCRIPTION' | translate"
                        icon="icon-alert"
                    >
                    </tec-tile>
                }
                @if (pageWarning.type === PAGE_WARNING.SERVER_ERROR) {
                    <tec-tile
                        type="status"
                        [title]="'LIFE_CHECK.PAGE_WARNING.SERVER_ERROR.TITLE' | translate"
                        [subtitle]="'LIFE_CHECK.PAGE_WARNING.SERVER_ERROR.DESCRIPTION' | translate"
                        icon="icon-alert"
                    >
                    </tec-tile>
                }
                @if (pageWarning.type === PAGE_WARNING.CAMERA_ERROR) {
                    <tec-tile
                        type="status"
                        [title]="'LIFE_CHECK.PAGE_WARNING.CAMERA_ERROR.TITLE' | translate"
                        [subtitle]="'LIFE_CHECK.PAGE_WARNING.CAMERA_ERROR.DESCRIPTION' | translate"
                        icon="icon-alert"
                    >
                    </tec-tile>
                }
                @if (pageWarning.type === PAGE_WARNING.INSUFFICIENT_OCR_READ) {
                    <tec-tile
                        type="status"
                        [title]="'OCR.PAGE_WARNING.INSUFFICIENT_OCR_READ.TITLE' | translate"
                        [subtitle]="'OCR.PAGE_WARNING.INSUFFICIENT_OCR_READ.DESCRIPTION' | translate">
                    </tec-tile>
                    <tec-tile type="default" styling="default">
                        <div class="grid grid-e3-sm grid-no-responsive">
                            <div class="image-group">
                                <pwcs-inline-svg
                                    [src]="getDniPhotoSideAsset('assets/images/id-bright.svg')"
                                    idSuffix="manual-ocr-insufficient-read-id-bright"
                                />
                                <span>{{ 'OCR.PAGE_WARNING.INSUFFICIENT_OCR_READ.TIP_BRIGHT' | translate }}</span>
                            </div>
                            <div class="image-group">
                                <pwcs-inline-svg
                                    [src]="getDniPhotoSideAsset('assets/images/id-cut.svg')"
                                    idSuffix="manual-ocr-insufficient-read-id-cut"
                                />
                                <span>{{ 'OCR.PAGE_WARNING.INSUFFICIENT_OCR_READ.TIP_FRAME' | translate }}</span>
                            </div>
                            <div class="image-group">
                                <pwcs-inline-svg
                                    [src]="getDniPhotoSideAsset('assets/images/id-blurred.svg')"
                                    idSuffix="manual-ocr-insufficient-read-id-blurred"
                                />
                                <span>{{ 'OCR.PAGE_WARNING.INSUFFICIENT_OCR_READ.TIP_LEGIBLE' | translate }}</span>
                            </div>
                        </div>
                    </tec-tile>
                }
            }

            <!-- HANDSETLANDSCAPE -->
            @if (handsetLandscape && !pageWarning.show) {
                <app-handset-landscape-tile />
            }
        }
    </ng-container>

    <!-- ACCIONES -->
    <ng-container actions>
        <!-- SIN PERMISOS -->
        @if (!permissionsCamera) {
            <tec-button type="secondary" [size]="'lg'" (clickEvent)="isVisibleChangeDevice = true">
                {{ 'GENERAL.BUTTON.OTHER_DEVICE' | translate }}
            </tec-button>
            <tec-button [size]="'lg'" (clickEvent)="checkPermissions()">
                {{ 'GENERAL.BUTTON.PERMISSIONS_ACTIVATED' | translate }}
            </tec-button>
        }

        <!-- CON PERMISOS -->
        @if (permissionsCamera) {
            <!-- TUTORIAL -->
            @if (operation?.config.tutorial && !pageWarning.show && !handsetLandscape) {
                <tec-button
                    [label]="'GENERAL.BUTTON.IM_READY' | translate"
                    [type]="'default'"
                    [size]="'lg'"
                    (clickEvent)="finishTutorial()"
                ></tec-button>
            }

            <!-- HELP -->
            @if (pageWarning.show) {
                @if (pageWarning.type === PAGE_WARNING.INSUFFICIENT_OCR_READ) {
                    <tec-button
                        [label]="'GENERAL.BUTTON.CHANGE_DEVICE' | translate"
                        [type]="'secondary'"
                        [size]="'lg'"
                        (clickEvent)="isVisibleChangeDevice = true"
                    ></tec-button>
                    <tec-button
                        [label]="'GENERAL.BUTTON.RETRY' | translate"
                        [type]="'default'"
                        [size]="'lg'"
                        (clickEvent)="retryInsufficientOcrRead()"
                    ></tec-button>
                }
                @if (pageWarning.type === PAGE_WARNING.HELP) {
                    <!-- DESDE SEGUNDO INTENTO -->
                    <tec-button
                        [label]="'GENERAL.BUTTON.GO_BACK' | translate"
                        [type]="'secondary'"
                        [size]="'lg'"
                        (clickEvent)="setPageWarning(null, false)"
                    ></tec-button>
                    <tec-button
                        [label]="'GENERAL.BUTTON.CHANGE_DEVICE' | translate"
                        [type]="'default'"
                        [size]="'lg'"
                        (clickEvent)="isVisibleChangeDevice = true"
                    ></tec-button>
                }
            }

            <!-- Botón para tomar foto -->
            @if (!operation?.config?.tutorial && !pageWarning.show && !handsetLandscape && selectedDocumentType) {
                @if (!capturedImage) {
                    <tec-button-icon
                        [type]="'circle'"
                        [icon]="'icon-camera'"
                        [size]="'lg'"
                        (clickEvent)="takePhoto()"
                    ></tec-button-icon>
                }
                @if (capturedImage) {
                    <tec-button
                        [label]="'GENERAL.BUTTON.REPEAT' | translate"
                        [type]="'secondary'"
                        [size]="'lg'"
                        (clickEvent)="repeatPhoto()"
                    ></tec-button>
                    <tec-button
                        [label]="'GENERAL.BUTTON.UPLOAD_PHOTO' | translate"
                        [type]="'default'"
                        [size]="'lg'"
                        (clickEvent)="sendResult(true)"
                    ></tec-button>
                }
            }
        }
    </ng-container>

    <!-- NAV HELP -->
    @if (
        !operation?.config?.iframe &&
        permissionsCamera &&
        !pageWarning.show &&
        !handsetLandscape &&
        !capturedImage
    ) {
        <tec-nav-help
            [elements]="operation?.config?.tutorial ? navsHelpTutorial : navsHelp"
            (clickEvent)="navHelpChange($event)"
        ></tec-nav-help>
    }

    <!-- WATERMARK -->
    @if ((designService.configDesign$ | async)?.showWatermark && !operation?.config?.iframe) {
        <tec-watermark type="default"></tec-watermark>
    }
</tec-pwcs-layout>

<app-modal-scan-qr
    [ngClass]="{ 'pwcs-style-old': operation.config?.iframe, dark: designService.isDarkMode() }"
    [(isVisible)]="isVisibleScan"
    [url]="auth.getQRUrl()"
></app-modal-scan-qr>

<app-modal-help-no-camera-permissions
    [ngClass]="{ 'pwcs-style-old': operation.config?.iframe, dark: designService.isDarkMode() }"
    [(isVisible)]="isVisibleHelpNoPermissionsCamera"
    [url]="auth.getQRUrl()"
></app-modal-help-no-camera-permissions>

<app-modal-change-device
    [ngClass]="{ 'pwcs-style-old': operation.config?.iframe, dark: designService.isDarkMode() }"
    [(isVisible)]="isVisibleChangeDevice"
    [url]="auth.getQRUrl()"
></app-modal-change-device>
